import { render, staticRenderFns } from "./ClientPostedTab.htm?vue&type=template&id=ba8f9a28&"
import script from "./ClientPostedTab.ts?vue&type=script&lang=js&"
export * from "./ClientPostedTab.ts?vue&type=script&lang=js&"
import style0 from "../MyJobsTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports